<div class="row">
  <label class="col-4 control-label">{{'i18n.base.user-add-modal.deposited-number-plates' | translate}}:</label>
</div>
<div class="row">
  <div class="col-12">
    <ejs-grid #grid
              class="grid-with-toolbar grid-with-footer"
              width="100%"
              rowHeight="38"
              [allowPaging]="true"
              [dataSource]="controlPlates"
              [editSettings]="editSettings"
              (actionComplete)="actionComplete($event)"
              (actionBegin)="actionBegin($event)">
      <ng-template #toolbarTemplate
                   let-data>
        <ejs-toolbar *ngIf="isUserStandardUser">
          <e-items>
            <e-item [text]="'i18n.base.user-add-modal.add-number-plate' | translate"
                    prefixIcon="e-icons icon-add"
                    (click)="onAdd()"></e-item>
          </e-items>
        </ejs-toolbar>
      </ng-template>
      <e-columns>
        <e-column headerText="id"
                  field="id"
                  [visible]="false"
                  [isPrimaryKey]="true"></e-column>
        <e-column [headerText]="'i18n.shared.fields.country' | translate"
                  field="countryCode"
                  clipMode="EllipsisWithTooltip"></e-column>
        <e-column field="controlPlateNumber"
                  headerText="{{'i18n.shared.fields.control-plate' | translate}}"
                  clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            <span class="text-uppercase">{{data.controlPlateNumber | translate}}</span>
          </ng-template>
        </e-column>
        <e-column field="controlPlateType"
                  headerText="{{'i18n.domain.parker-administration.form.controlPlateType' | translate}}"
                  clipMode="EllipsisWithTooltip">
          <ng-template #filterItemTemplate let-data>{{formatControlPlateType(data) | translate}}</ng-template>
          <ng-template #template let-data>
            {{formatControlPlateType(data) | translate}}
          </ng-template>
        </e-column>
        <e-column headerText=""
                  [commands]="gridCommands"
                  width="100px"
                  *ngIf="isUserStandardUser"></e-column>
      </e-columns>
      <ng-template #editSettingsTemplate
                   let-data>
        <form [formGroup]="gridEditForm">
          <div class="form-row row">
            <div class="form-group col-12 col-md-12">
              <label for="country"
                     class="control-label required">{{'i18n.shared.fields.country' | translate}}</label>
              <app-autocomplete #countryAutocomplete
                                [getDataFunction]="getCountries.bind(this)"
                                [fields]="dropdownSettings"
                                [(value)]="selectedCountry"
                                [isFormComponent]="true"
                                id="country">
              </app-autocomplete>
            </div>
          </div>
          <div class="form-row row">
            <div class="form-group col-12 col-md-12">
              <label for="controlPlateNumber"
                     class="control-label required">{{'i18n.shared.fields.control-plate' | translate}}</label>
              <input id="controlPlateNumber"
                     type="text"
                     class="form-control"
                     formControlName="controlPlateNumber"/>
              <app-error-messages [control]="gridEditForm.controls.controlPlateNumber"></app-error-messages>
            </div>
          </div>
          <div class="form-row row">
            <div class="form-group col-md-12">
              <label for="controlPlateType"
                     class="control-label required">{{'i18n.domain.parker-administration.form.controlPlateType' | translate}}</label>
              <app-enum-drop-down-list formControlName="controlPlateType"
                                       id="controlPlateType"
                                       width="100%"
                                       [enumType]="ControlPlateType"
                                       [showClearButton]="false"
                                       baseTranslationString="i18n.shared.controlPlateType."></app-enum-drop-down-list>
            </div>
          </div>
        </form>
      </ng-template>
    </ejs-grid>
  </div>
</div>
